import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { StoreState } from "../models/states/StoreState";
import { RecallType } from "../piping/RecallType";
import { getRecall } from "../redux/reducers/recallReducer";
import { evaluateRecalls } from "../redux/thunks/recall";

export default function useRecall<T extends string | ReadonlyArray<string>>(
    text: T,
    type: RecallType = RecallType.Text,
): T {
    const dispatch = useDispatch();
    const recalled = useSelector((state: StoreState) => {
        if (text == null) return text;
        if (typeof text === "string") return getRecall(state.recall, text, type);
        return (text as ReadonlyArray<string>).map((t) => getRecall(state.recall, t, type));
    }, shallowEqual);

    let recalledText = recalled;
    if (typeof text === "string" && recalled === undefined && text && type) {
        recalledText = dispatch(evaluateRecalls(text, type));
    }
    if (typeof text === "object" && recalled === undefined && text && type) {
        recalledText = (text as ReadonlyArray<string>).map((t) =>
            dispatch(evaluateRecalls(t, type)),
        );
    }
    return recalledText;
}
